import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import Contact from '../views/Contact.vue';
import NewsPage from '../views/NewsPage.vue';
import Partners from '../views/Partners.vue';
import ProductExamples from '../views/ProductExamples.vue';
import Issue from '../views/Issue.vue';
import Concerning from '../views/Concerning.vue';
import Privacy from '../views/Privacy.vue';
import Serve from '../views/Serve.vue';
import Article from '../views/Article.vue';


Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  }
  ,
  {
    path: '/newsPage',
    name: 'NewsPage',
    component: NewsPage
  }
  ,
  {
    path: '/partners',
    name: 'Partners',
    component: Partners
  }
  ,
  {
    path: '/productExamples',
    name: 'ProductExamples',
    component: ProductExamples
  }
  ,
  {
    path: '/issue',
    name: 'Issue',
    component: Issue
  }
  ,
  {
    path: '/concerning',
    name: 'Concerning',
    component: Concerning
  }
  ,
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  }
  ,
  {
    path: '/serve',
    name: 'Serve',
    component: Serve
  }
  ,
  {
    path: '/article',
    name: 'Article',
    component: Article
  }
];

const router = new Router({
  mode: 'history', // 使用 HTML5 History 模式
  routes,
  scrollBehavior(to) {
    return new Promise((resolve) => {
      // 先滚动到顶部
      window.scrollTo(0, 0);

      // 判断是否为首页
      if (to.path === '/') {
        resolve(); // 如果是首页，直接解析 Promise，不执行后续滚动
        return;
      }

      const targetPosition = window.innerHeight - 80; // 获取屏幕高度减去80px
      const duration = 100; // 动画持续时间，单位为毫秒
      const startPosition = window.scrollY; // 当前滚动位置
      const distance = targetPosition - startPosition; // 需要滚动的距离
      let startTime = null;

      function animation(currentTime) {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1); // 计算进度

        // 使用线性插值来实现直线滚动
        window.scrollTo(0, startPosition + distance * progress);

        if (progress < 1) {
          requestAnimationFrame(animation); // 继续动画
        } else {
          resolve(); // 动画结束后解析 Promise
        }
      }

      requestAnimationFrame(animation); // 开始动画
    });
  }
});


export default router;
